// MA02 엑셀 업로드 — 1.0 TOOL_IMP 파리티 (CommonUtil.onImportExcel: 클라 파싱 → 그리드 반영 → 저장 배치)
// 서버 업로드 API 는 1.0 에도 없음 — xlsx 를 exceljs 로 파싱해 한글 헤더를 컬럼 키로 매핑,
// 각 데이터 행을 "신규 행" 으로 반환한다 (사용자가 검토·선택 후 [저장] = POST/PUT 경로 재사용).
import ExcelJS from 'exceljs'
import { EXPORT_COLUMNS } from './consts'

/** 업로드 반영 대상 — 편집 가능 컬럼 + 식별(바코드) 만 수용한다 (표시 전용/파생 컬럼은 무시) */
const IMPORTABLE_KEYS = new Set([
  'SPR_NM',
  'GDS_GROUP1',
  'BRD_NM',
  'STL_NO',
  'BARCODE',
  'GDS_CD',
  'GDS_NM',
  'GDS_OPT',
  'GDS_COLOR',
  'GDS_ATTR1',
  'AP_PRICE',
  'AR_PRICE',
  'UID',
  'product_image_url',
])

const titleToKey = new Map(EXPORT_COLUMNS.map((c) => [c.title, c.key]))

export interface ImportedRow {
  [key: string]: string | number
}

export const parseProductExcel = async (file: File): Promise<ImportedRow[]> => {
  const wb = new ExcelJS.Workbook()
  await wb.xlsx.load(await file.arrayBuffer())
  const ws = wb.worksheets[0]
  if (!ws) return []

  // 1행 = 한글 헤더 (다운로드 양식과 동일 — EXPORT_COLUMNS title 기준 매핑)
  const headerKeys: (string | null)[] = []
  ws.getRow(1).eachCell({ includeEmpty: true }, (cell, col) => {
    const key = titleToKey.get(String(cell.value ?? '').trim()) ?? null
    headerKeys[col] = key && IMPORTABLE_KEYS.has(key) ? key : null
  })
  if (!headerKeys.some(Boolean)) {
    throw new Error('헤더를 인식할 수 없습니다. 엑셀 다운로드 양식과 동일한 1행 헤더가 필요합니다.')
  }

  const rows: ImportedRow[] = []
  ws.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return
    const item: ImportedRow = {}
    let hasValue = false
    row.eachCell({ includeEmpty: true }, (cell, col) => {
      const key = headerKeys[col]
      if (!key) return
      const raw = cell.value
      const text = raw == null ? '' : typeof raw === 'object' && 'text' in (raw as object) ? String((raw as { text: unknown }).text) : String(raw)
      if (!text.trim()) return
      hasValue = true
      item[key] = key === 'AP_PRICE' || key === 'AR_PRICE' ? Number(text) || 0 : text.trim()
    })
    if (hasValue) rows.push(item)
  })
  return rows
}
